'use client';

import { alpha, Button } from '@mui/material';

import { useT } from '@/hooks';

interface DepositButtonProps {
  onClick: () => void;
}

export const DepositButton = ({ onClick }: DepositButtonProps) => {
  const { t } = useT();
  return (
    <Button
      variant="contained"
      onClick={onClick}
      sx={{
        display: { xs: 'none', md: 'inline-flex' },
        borderRadius: '9px',
        textTransform: 'none',
        fontWeight: 600,
        px: { md: 1.5, lg: 1.75 },
        py: { md: 0.5, lg: 0.625 },
        fontSize: { md: '0.8125rem', lg: '0.875rem' },
        background: (theme) =>
          `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        border: 'none',
        boxShadow: (theme) =>
          `0 4px 12px ${alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.3 : 0.2)}`,
        minHeight: { md: '32px', lg: '34px' },
        transition: 'all 0.2s ease',
        '&:hover': {
          background: (theme) =>
            `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${alpha(theme.palette.primary.dark, 0.9)} 100%)`,
          boxShadow: (theme) =>
            `0 6px 16px ${alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.4 : 0.3)}`,
          transform: 'translateY(-1px)',
        },
        '&:active': {
          transform: 'translateY(0)',
        },
      }}
    >
      {t('nav.deposit')}
    </Button>
  );
};
